import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import './index.css';
import App from './App.js';
// import Blog from './pages/Blog/blog_landing.js';
// import Projects from './pages/Projects/projects.js';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <BrowserRouter basename="/">
      <div>
        <Switch>
          {/* App handles all in-app routing (incl. /blog/<slug> post subpages) */}
          <Route path="/" component={App} />
        </Switch>
      </div>
    </BrowserRouter>,
    document.getElementById("root"),
  );
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
